module.exports = __webpack_public_path__ + "img/24.ccdbfc17.png";